import React from 'react';
import styled from 'styled-components';

import { printCondition } from '../../constants/media';
import { backgroundMain, textMain } from '../../constants/colors';
import { bodyFontStack } from '../../fonts';

const Print = styled.div`
  @media ${printCondition} {
    nav,
    .toggle {
      display: none;
    }

    @page {
      margin: 8mm 0.1mm 8mm 0.1mm !important;
      /* The page margin sits outside html, so without this it prints white */
      background-color: ${backgroundMain};

      @bottom-right {
        content: counter(page);
        padding-right: 12mm;
        font-family: ${bodyFontStack};
        font-size: 9pt;
        color: ${textMain};
      }
    }

    body {
      padding: 0 !important;
      margin: 0 !important;
    }

    a[href^="http://"]:after,
    a[href^="https://"]:after
    {
      content: ' (' attr(href) ')';
      font-size: 90%;
    }

    table {
      page-break-inside: auto;
    }

    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    thead {
      display: table-header-group; /* Repeat headers */
    }
  }
`;

export const PrintDefault = (props) => {
  const { children } = props;

  return <Print>{children}</Print>;
};
